/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-12",
    versionChannel: "nightly",
    buildDate: "2023-03-12T00:19:04.440Z",
    commitHash: "1deebc87e869387c962f97b665d26785d0a2b52f",
};
